import { Dialog, DialogContent } from '@mui/material';
import { FormikProvider, useFormikContext } from 'formik';
import React, { useState } from 'react';

import Icon from '@components/Icon/Icon';
import RelatedRecordsModalContent from '@components/Modal/Content/RelatedRecordsModalContent';

const RelatedRecordsButton: React.FC<{ associations?: string[] }> = ({
  associations,
}) => {
  const formik = useFormikContext();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Icon
        clickable
        color="primary.main"
        name="plus"
        onClick={handleOpen}
        size="lg"
        type="fas"
      />
      <Dialog fullWidth maxWidth="xl" onClose={handleClose} open={open}>
        <FormikProvider value={formik}>
          <DialogContent>
            <RelatedRecordsModalContent
              associations={associations}
              onClose={handleClose}
            />
          </DialogContent>
        </FormikProvider>
      </Dialog>
    </>
  );
};

export default RelatedRecordsButton;
